export default {
    name: 'meteodata',
    serverName: '/api/v1/weather/field_weather/',
    apiUrl: '/api/v1/weather/field_weather/'
};